import styled from "styled-components";

import { ExternalLink } from "ui/Link";

import { LoginWithGoogleButton } from "../login-with-google-button";

export function YoutubeConnectInstructions({
  ButtonProps,
}: {
  ButtonProps: { disabled: boolean; onClick(): void };
}) {
  return (
    <Root>
      <p>
        To connect your YouTube channel(s), we need to authorise your Google
        account.
      </p>
      <p>
        You will need to have access to the YouTube channel for us to post to
        it. You can{" "}
        <ExternalLink href="https://www.youtube.com/">
          check the channels your Google account has access to
        </ExternalLink>{" "}
        (click your profile picture in the top right then 'Your channel' or
        under 'Switch account').
      </p>
      <p>
        After authorising our access, you'll pick the specific channel(s) to
        connect.
      </p>
      <p>
        If you need to change the Google account permissions you have given to
        us, use{" "}
        <ExternalLink
          href="https://myaccount.google.com/permissions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google's permissions tool
        </ExternalLink>
        .
      </p>
      <ButtonContainer>
        <LoginWithGoogleButton {...ButtonProps} />
      </ButtonContainer>
    </Root>
  );
}

const Root = styled.div`
  & > p {
    margin: 0;
  }

  & > p:not(:first-of-type) {
    margin-top: 10px;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 12px;

  display: flex;
  justify-content: center;
`;
